module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/how-bg-02f7c4f330539f6a64532aa6b2e47280.svg";